import { useState, useEffect } from 'react';
import { Modal, Badge } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';

import { buscarUsuarios, limpiarUsuarios } from '../../actions/usuarios';
import { asignarAsesoria } from '../../actions/asesorias';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const AsignarAsesoria = ({ asesoria, reestablecerAsesoria }) => {

    const dispatch =  useDispatch();

    const { listado } = useSelector(state => state.usuarios);

    const [asignarModal, setAsignarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [asignarData, setAsignarData] = useState({
        id: null,
        asesor: null
    });

    const [asesorData, setAsesorData] = useState(null);
    const [asesoresFilter, setAsesoresFilter] = useState([]);
    const [asesorPredilecto, setAsesorPredilecto] = useState(null);

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided, 
        }),
        control: (provided, state) => ({
            ...provided,
            paddingTop: '5px',
            paddingBottom: '5px',
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible", 
            marginTop: "10px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Asignar asesoria */
    const handleAbrir = () => {
        dispatch(buscarUsuarios({
            id: null, 
            nombre: null, 
            apellido_paterno: null, 
            apellido_materno: null, 
            tipo: null, 
            fecha_inicio: null, 
            fecha_fin: null
        }));
    }

    const handleSelectAsesor = (option) => {
        setAsesorData(option);

        setAsignarData({
            ...asignarData,
            asesor: option != null ? option.value : null
        });
    }

    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(asignarAsesoria(asignarData));
        await handleCerrar(null);
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerAsesoria(null);
            setAsignarModal(false);
            setAsesorData(null);
            setAsesoresFilter([]);
            setAsesorPredilecto(null);
            setAsignarData({
                id: null,
                asesor: null
            });

            dispatch(limpiarUsuarios());
        }
    }

    useEffect(() => {
        if(asesoria != null){
            setAsignarModal(true);

            setAsignarData({
                id: asesoria._id,
                asesor: asesoria.asesor._id || null
            });

            if(asesoria.asesor?._id){
                setAsesorData({value: asesoria.asesor._id, label: asesoria.asesor.nombre_completo});
            }

            setAsesorPredilecto(asesoria.asesor_predilecto || null);
        }
    }, [asesoria]);

    useEffect(() => {
        let options = listado?.map(u => ({
            value: u._id,
            label: [u.nombre, u.apellido_paterno, u.apellido_materno].join(' '),
            clientes_asignados: u.clientes_asignados ?? 0,
            recomendado: asesorPredilecto?._id && u._id?.toString() === asesorPredilecto._id?.toString()
        })) || [];

        options.sort((a, b) => (b.recomendado ? 1 : 0) - (a.recomendado ? 1 : 0));

        setAsesoresFilter(options);
    }, [listado, asesorPredilecto]);

    const formatOptionLabel = (option) => (
        <span className="d-flex align-items-center justify-content-between">
            <span>
                {option.label}
                {option.recomendado && <Badge pill bg="success" className="ms-2" style={{ fontSize: '0.7rem' }}>Asesor recomendado</Badge>}
            </span>
            <span className="text-muted ms-3" style={{ fontSize: '0.78rem', whiteSpace: 'nowrap' }}>
                <i className="fas fa-users fa-xs me-1"></i>{option.clientes_asignados}
            </span>
        </span>
    );

    return (
        <Modal show={asignarModal} backdrop="static" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Asignar asesoría</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                id="asesor"
                                name="asesor"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Asesor"
                                isClearable={true}
                                options={asesoresFilter}
                                value={asesorData}
                                onChange={(value) => handleSelectAsesor(value)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                formatOptionLabel={formatOptionLabel}
                            />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> Cancelar</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Guardar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Guardar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default AsignarAsesoria;